import jsPDF from "jspdf";
import moment from "moment/moment";
import { calculateTotals } from "./PurchaseParty";
import logo from "../assests/images/logo2.png";

const PartyHistroy = [
  "S.No",
  "Date",
  "Bill No",
  "Amount",
  "Paid",
  "Payment Method",
  "Balance",
  "Details",
];

export const generatePurchasePartyPdf = (
  clickedData,
  errorAlert,
  from_date,
  to_date
) => {
  if (
    !clickedData ||
    !clickedData.transactions ||
    clickedData.transactions.length === 0
  ) {
    errorAlert("No transactions data to export.");
    return;
  }

  const { paid: totalPaid, balance: totalBalance } = calculateTotals(
    clickedData ? clickedData.transactions : []
  );

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const startX = 14;
  const endX = pageWidth - 14;
  const center = pageWidth / 2;
  const tableWidth = endX - startX;

  let startY = 10;
  const lineHeight = 7;
  let currentY = startY;

  const drawCell = (x, y, width, height, style = "S") => {
    doc.rect(x, y, width, height, style);
  };

  const headerCardHeight = 15;
  const logoSize = 15;
  const headerColor = [30, 58, 138];
  const cardBackgroundColor = [240, 240, 240];
  const cardTextY = currentY + headerCardHeight / 2;

  doc.setFillColor(...cardBackgroundColor);
  drawCell(startX, currentY, tableWidth, headerCardHeight, "F");
  doc.setFontSize(18);
  doc.setFont(undefined, "bold");
  doc.setTextColor(...headerColor);
  doc.text("MKS", center, cardTextY, {
    align: "center",
    baseline: "middle",
  });

  //Logo Implementation
  const logoX = startX + 2;
  const logoY = currentY + (headerCardHeight - logoSize) / 2;

  if (logo) {
    doc.addImage(logo, "PNG", logoX, logoY, logoSize, logoSize);
  }

  currentY += headerCardHeight + 2;

  doc.setFontSize(12);
  doc.setFont(undefined, "bold");
  const text = `Purchase Transaction Details for: ${clickedData.party_name}`;
  doc.text(text, doc.internal.pageSize.width / 2, currentY + 6, {
    align: "center",
  });
  currentY += 14;

  const formattedFromDate = from_date
    ? moment.utc(from_date, "YYYY-MM-DD").format("DD MMMM YYYY")
    : "-";
  const formattedToDate = to_date
    ? moment.utc(to_date, "YYYY-MM-DD").format("DD MMMM YYYY")
    : "-";

  currentY += 5;

  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  doc.setTextColor(0, 0, 0);

  // From Date
  if(formattedFromDate !== "-") {
  doc.text(`From Date:`, startX, currentY);
  doc.setFont(undefined, "normal");
  doc.text(formattedFromDate, startX + 25, currentY);
  }

  currentY += 5;

  // To Date
  if(formattedToDate !== "-") {
  doc.setFont(undefined, "bold");
  doc.text(`To Date:`, startX, currentY);
  doc.setFont(undefined, "normal");
  doc.text(formattedToDate, startX + 25, currentY);
  }

  currentY += 5;

  // --- START OF TABLE HEADER DRAWING ---
  const finalColumnWidths = [12, 23, 25, 20, 15, 30, 20, 35];
  let currentX = startX;

  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.setTextColor(0, 0, 0);

  for (let i = 0; i < PartyHistroy.length; i++) {
    const width = finalColumnWidths[i];

    doc.setFillColor(220, 220, 220);
    doc.rect(currentX, currentY, width, lineHeight, "F");
    drawCell(currentX, currentY, width, lineHeight);

    doc.text(
      PartyHistroy[i],
      currentX + width / 2,
      currentY + lineHeight / 2 + 1.5,
      { align: "center" }
    );
    currentX += width;
  }
  //table data
  doc.setFont(undefined, "normal");
  doc.setFontSize(8);
  doc.setTextColor(0, 0, 0);
  currentY += lineHeight;

  // Sort transactions by date in ascending order
const sortedTransactions = [...clickedData.transactions].sort(
  (a, b) => new Date(a.date) - new Date(b.date)
);


  sortedTransactions.forEach((t, index) => {
    currentX = startX;
    const rowData = [
      index + 1,
      moment(t.date).format("DD/MM/YY"),
      t.receipt_no,
      t.amount,
      t.paid,
      t.payment_method,
      t.balance,
      t.details || "-",
    ];

    rowData.forEach((cellData, i) => {
      const width = finalColumnWidths[i];

      drawCell(currentX, currentY, width, lineHeight);

      let align = "left";
      let offset = 2;

      if (i === 0) {
        align = "center";
        offset = width / 2;
      } else if (i === 2) {
        align = "center";
        offset = width / 2;
      } else if (i >= 3) {
        align = "right";
        offset = width - 2;
      }

      doc.text(
        String(cellData),
        currentX + offset,
        currentY + lineHeight / 2 + 1.5,
        { align: align }
      );

      currentX += width;
    });

    currentY += lineHeight;
  });

  // --- START OF TOTALS ---
  const totalTableWidth = finalColumnWidths.reduce((a, b) => a + b, 0);
  const rightAlignX = startX + totalTableWidth;

  currentY += 5;
  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  doc.setTextColor(0, 0, 0); // Black
  doc.text("TOTAL PAID:", rightAlignX - 40, currentY, { align: "right" });

  doc.text(totalPaid, rightAlignX, currentY, { align: "right" });

  currentY += lineHeight;

  doc.text("TOTAL BALANCE:", rightAlignX - 40, currentY, { align: "right" });

  doc.setTextColor(0, 0, 0);
  doc.text(totalBalance, rightAlignX, currentY, { align: "right" });

  currentY += lineHeight;

  doc.setTextColor(0, 0, 0);
  doc.setFont(undefined, "normal");

  doc.save(
    `Transactions_${clickedData.party_name.replace(
      /\s+/g,
      "_"
    )}_${moment().format("YYYYMMDD")}.pdf`
  );
};
